import React from 'react';
import { Box, Container, Typography, Link, Stack } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import { translations } from '../translations';

const Footer = ({ language }: { language: string }) => {
  const t = translations[language === 'ku' ? 'ku' : 'en'];
  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: 'auto',
        backgroundColor: (theme) => theme.palette.grey[100],
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <Typography variant="body2" color="text.secondary">
            © {new Date().getFullYear()} {t.appName}. {t.allRightsReserved}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {t.notice}
          </Typography>
          
          <Stack direction="row" spacing={2}>
            <Link href="https://www.facebook.com/kurdcode" color="inherit">
              <FacebookIcon />
            </Link>
            <Link href="https://www.twitter.com/kurdcode" color="inherit">
              <TwitterIcon />
            </Link>
            <Link href="https://www.instagram.com/kurdcode" color="inherit">
              <InstagramIcon />
            </Link>
          </Stack>

          <Stack 
            direction={{ xs: 'column', sm: 'row' }} 
            spacing={2}
            sx={{ textAlign: 'center' }}
          >
            <Link href="#" color="inherit" underline="hover">
              {t.privacyPolicy}
            </Link>
            <Link href="#" color="inherit" underline="hover">
              {t.termsOfService}
            </Link>
            <Link href="#" color="inherit" underline="hover">
              {t.contactUs}
            </Link>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 